import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { fetchOrg, fetchOrgProperties } from 'app/modules/org/actions'
import { refreshCurrentUser } from 'app/modules/user/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Button, Icon } from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'
import ConnectButton from '../../components/ConnectButton'
import './style.styl'

const CONTACT_UPDATE_MESSAGE = `Create and update contacts in Marketo when they interact with Drift`
const ACTIVITY_PUSH_MESSAGE = `Push conversation, qualification score updates, and new meeting activities to Marketo`
const IDENTIFY_CONTACT_MESSAGE = `Identify unknown visitors using Marketo Munchkin Cookies`

class MarketoIntegrationPage extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  refreshProperties = () => {
    return this.props.actions.fetchOrgProperties()
  }

  refreshGates = () => {
    return this.props.actions.refreshCurrentUser()
  }

  onConnectClicked = () => {
    this.context.router.push('/settings/setup/marketo-config')
  }

  render() {
    const { isConnected }= this.props
    return (
      <div className="marketo-integration-page">

        <div className="marketo-overview-container">
          <div className="marketo-overview-description">
            <Icon className="anonymous-visitor-icon" width={50} height={22} name="rolodex"/>
            <p>{CONTACT_UPDATE_MESSAGE}</p>
          </div>
          <div className="marketo-overview-description">
            <Icon className="activity-icon" width={50} name="activity"/>
            <p>{ACTIVITY_PUSH_MESSAGE}</p>
          </div>
          <div className="marketo-overview-description">
            <Icon className="user-target-icon" width={50} name="user-target"/>
            <p>{IDENTIFY_CONTACT_MESSAGE}</p>
          </div>

          <p className="integration-page-description">
            Need some help? <a href="https://gethelp.drift.com/hc/en-us/articles/360041782994-Marketo-Integration" target="_blank">Learn more here!</a>
          </p>
        </div>

        {isConnected &&
          <Link to="/settings/marketo/config" className="integration-config-link">
            <h2 className="integration-section-title">
              Synced Marketo Data
            </h2>
            <p>Choose which data is sent between Marketo and Drift.</p>
          </Link>
        }
        {(isConnected && ACCESS.hasGates('MARKETO_MAPPING')) &&
          <Link to="/settings/marketo/mapping/attributes" className="integration-config-link">
            <h2 className="integration-section-title">
              Mapped Marketo Attributes
            </h2>
            <p>Map which fields you want to sync between Drift and Marketo.</p>
          </Link>
        }
        {(isConnected && ACCESS.hasGates('HAS_MARKETO_SYNC_LIST')) &&
          <div className="integration-config-section">
            <div>
              <h2 className="integration-section-title">
                Import Lists from Marketo
              </h2>
              <p>Sync Marketo Lists into Drift to use as segments.</p>
            </div>
            <Button type="tertiary" href="/contacts/imports" target="_blank">Go to Imports</Button>
          </div>
        }
        {!isConnected &&
          <div className="marketo-connect-button">
            <ConnectButton onClick={this.onConnectClicked} />
          </div>
        }

        {isConnected &&
          <Link to="/settings/marketo/event-log" className="integration-config-link">
            View Marketo Event Log
          </Link>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  orgProperties: OrgSelectors.properties(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchOrg, fetchOrgProperties, refreshCurrentUser }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withNotifications(MarketoIntegrationPage)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoIntegrationPage/index.js